import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import servicesBg from "../assets/img/myServicesImg1.jpeg";
import "animate.css";
import { useState } from "react";
import TrackVisibility from "react-on-screen";

export const Styles = () => {
  const tearLinks = {
    "3d-visuals": [
      "https://www.youtube.com/embed/3n2D3YFYq_s",
      "https://www.youtube.com/embed/uBPyh0ok7lM",
    ],

    "advance-documentary": [
      "https://www.youtube.com/embed/NfjPiOUzkNo",
      "https://www.youtube.com/embed/eN4aJIKgasA",
      "https://www.youtube.com/embed/N0hQC9D97Wo",
      "https://www.youtube.com/embed/nfN3g0S3xog",
    ],

    "camera-animation": [
      "https://www.youtube.com/embed/xWv9QWvLUuU",
      "https://www.youtube.com/embed/xz0ms2SR_Tw",
      "https://www.youtube.com/embed/my_D76C7ubE",
      "https://www.youtube.com/embed/oFuBjn7ppdA",
    ],

    podcast: [
      "https://www.youtube.com/embed/S85mPFKw0aw",
      "https://www.youtube.com/embed/iXOzt1KyZVE",
    ],

    "talking-head": [
      "https://www.youtube.com/embed/8xEG4jw2CR4",
      "https://www.youtube.com/embed/xpNtx6DMM9Q",
      "https://www.youtube.com/embed/ri7EYMcHHO0",
      "https://www.youtube.com/embed/PLWZzHIzr6c",
      "https://www.youtube.com/embed/Lpnvpt6c-Uw",
    ],

    entertainment: [
      "https://www.youtube.com/embed/MBWKg3jJ7O4",
      "https://www.youtube.com/embed/b7btrvoWpuI",
      "https://www.youtube.com/embed/l_aQzviw9Z0",
      "https://www.youtube.com/embed/1oCbfGhSg7A",
      "https://www.youtube.com/embed/RnxTAE34qjs",
      "https://www.youtube.com/embed/HRMNhPCpH24",
    ],

    advertisement: [
      "https://www.youtube.com/embed/_d5QUEEWfvc",
      "https://www.youtube.com/embed/jd2enKkgCHk",
      "https://www.youtube.com/embed/b2-gcCgIJC4",
    ],

    "ai-visuals": [
      "https://www.youtube.com/embed/2T5nZkvun90",
      "https://www.youtube.com/embed/YT9Dz95XdZ0",
      "https://www.youtube.com/embed/dlnrA6ANMiY",
      "https://www.youtube.com/embed/qJ8ext6p59Y",
      "https://www.youtube.com/embed/0D2sp6uS8OA",
      "https://www.youtube.com/embed/OBUYYS4tiDE",
    ],

    "cartoon-animation": [
      "https://www.youtube.com/embed/T3RzKfBXvQI",
      "https://www.youtube.com/embed/agzcmUvQYEE",
      "https://www.youtube.com/embed/u6hgppZ9w0w",
      "https://www.youtube.com/embed/4MZMll-BVvQ",
    ],

    "character-animation": [
      "https://www.youtube.com/embed/D6wOG1JA5zI",
      "https://www.youtube.com/embed/ZHA1kofQ1FE",
      "https://www.youtube.com/embed/JQwPH0vRD5U",
    ],

    documentary: [
      "https://www.youtube.com/embed/t-K4_Tw2RS4",
      "https://www.youtube.com/embed/gwjvIqhBCuk",
      "https://www.youtube.com/embed/Ir9n6uAAK48",
      "https://www.youtube.com/embed/xDQ2o-MmVPA",
      "https://www.youtube.com/embed/jZF3CG3Rlvs",
      "https://www.youtube.com/embed/D3f2RsjIMQ4",
      "https://www.youtube.com/embed/TbJaQVNwsE4",
      "https://www.youtube.com/embed/LxmJ2Jq4Itc",
      "https://www.youtube.com/embed/ao-ofNmE2Js",
      "https://www.youtube.com/embed/-nCgFcUk_y8",
    ],

    "stick-animation": [
      "https://www.youtube.com/embed/JexKO-x-fqo",
      "https://www.youtube.com/embed/tjXkjzVHz7Y",
    ],

    "image-animation": [
      "https://www.youtube.com/embed/4--zAeg1E0Q",
      "https://www.youtube.com/embed/Ch8KEU279Pg",
      "https://www.youtube.com/embed/KyoRZzdp4e0",
    ],

    shorts: [
      "https://www.youtube.com/embed/pnOPQHixn8w",
      "https://www.youtube.com/embed/aLDBhdUlIGU",
      "https://www.youtube.com/embed/w5MkWSaS-gI",
      "https://www.youtube.com/embed/97_v2QdIx7U",
      "https://www.youtube.com/embed/G0EHpvbJEAA",
      "https://www.youtube.com/embed/9UiedfscEc0",
      "https://www.youtube.com/embed/VAG56saph64",
      "https://www.youtube.com/embed/Kw3-qwkHr6Y",
      "https://www.youtube.com/embed/BbHVSXcw3NY",
    ],
  };

  const [activeTab, setActiveTab] = useState(Object.keys(tearLinks)[0]);

  const CustomLeftArrow = ({ onClick }) => {
    const [hover, setHover] = useState(false);
    return (
      <div
        onClick={() => {
          const tabs = Object.keys(tearLinks);
          const currentIndex = tabs.indexOf(activeTab);
          const newIndex =
            currentIndex === 0 ? tabs.length - 1 : currentIndex - 1;
          setActiveTab(tabs[newIndex]);
          if (onClick) onClick();
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          position: "absolute",
          left: -8,
          width: 50,
          height: 50,
          top: "45%",
          transform: "translateY(-50%)",
          zIndex: 100,
          cursor: "pointer",
          backgroundColor: hover ? "#00000099" : "#00000099",
          borderRadius: "50%",
          transition: "0.3s",
          boxShadow: hover ? "2px 1px 5px rgba(255, 255, 255, 0.6)" : "",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <span style={{ color: "#fff", fontSize: 30 }}>‹</span>
      </div>
    );
  };

  const CustomRightArrow = ({ onClick }) => {
    const [hover, setHover] = useState(false);
    return (
      <div
        onClick={() => {
          const tabs = Object.keys(tearLinks);
          const currentIndex = tabs.indexOf(activeTab);
          const newIndex =
            currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
          setActiveTab(tabs[newIndex]);
          if (onClick) onClick();
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          position: "absolute",
          right: -8,
          width: 50,
          height: 50,
          top: "45%",
          transform: "translateY(-50%)",
          zIndex: 2,
          cursor: "pointer",
          backgroundColor: hover ? "#00000099" : "#00000099",
          borderRadius: "50%",
          transition: "0.3s",
          boxShadow: hover ? "2px 1px 5px rgba(255, 255, 255, 0.6)" : "",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <span style={{ color: "#fff", fontSize: 30 }}>›</span>
      </div>
    );
  };

  return (
    <section
      className="project"
      id="editingStyles"
      style={{
        backgroundImage: `url(${servicesBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
        paddingTop: "80px",
        paddingBottom: "80px",
      }}
    >
      <Container style={{ position: "relative", zIndex: 1 }}>
        <Row>
          <Col xs={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={`text-center ${
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }`}
                >
                  <h2>My Services</h2>
                  <p style={{ width: "80%", marginBottom: 80, marginTop: 20 }}>
                    Every style we offer has its own specific time limit and
                    associated cost tailored to that style. If the video you’re
                    working on ends up going beyond 8-10 minutes in length,
                    there will be additional charges applied, calculated on a
                    per-minute basis for the extra time.
                  </p>
                  <Tab.Container
                    id="projects-tabs"
                    activeKey={activeTab}
                    onSelect={(key) => setActiveTab(key)}
                    unmountOnExit
                  >
                    <Row>
                      {/* LEFT SIDE VERTICAL TABS */}
                      <Col md={3}>
                        <Nav
                          variant="pills"
                          className="flex-column nav-pills custom-tabs"
                          id="pills-tab"
                        >
                          <Nav.Item>
                            <Nav.Link eventKey="3d-visuals">
                              3D Visuals
                            </Nav.Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Nav.Link eventKey="advance-documentary">
                              Advance Documentary
                            </Nav.Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Nav.Link eventKey="camera-animation">
                              Camera Animation
                            </Nav.Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Nav.Link eventKey="podcast">Podcast</Nav.Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Nav.Link eventKey="talking-head">
                              Talking Head
                            </Nav.Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Nav.Link eventKey="entertainment">
                              Entertainment
                            </Nav.Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Nav.Link eventKey="advertisement">
                              Advertisement
                            </Nav.Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Nav.Link eventKey="ai-visuals">
                              AI-Visuals
                            </Nav.Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Nav.Link eventKey="cartoon-animation">
                              Cartoon Animation
                            </Nav.Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Nav.Link eventKey="character-animation">
                              Character Animation
                            </Nav.Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Nav.Link eventKey="documentary">
                              Documentary
                            </Nav.Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Nav.Link eventKey="stick-animation">
                              Stick Animation
                            </Nav.Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Nav.Link eventKey="image-animation">
                              Image Animation
                            </Nav.Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Nav.Link eventKey="shorts">Shorts</Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </Col>

                      {/* RIGHT SIDE CONTENT */}
                      <Col md={9}>
                        <Tab.Content
                          id="slideInUp"
                          className={
                            isVisible
                              ? "animate__animated animate__slideInUp"
                              : ""
                          }
                        >
                          {Object.keys(tearLinks).map((tabKey) => (
                            <Tab.Pane eventKey={tabKey} key={tabKey}>
                              <div style={{ position: "relative" }}>
                                <CustomLeftArrow />

                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "center",
                                    gap: "50px",
                                  }}
                                >
                                  {tearLinks[tabKey].map((link, index) => (
                                    <iframe
                                      key={index}
                                      src={link}
                                      width={
                                        tabKey === "shorts" ? "22%" : "38%"
                                      }
                                      height={
                                        tabKey === "shorts" ? "380" : "230"
                                      }
                                      style={{
                                        border: "none",
                                        margin: "10px",
                                        borderRadius:
                                          tabKey === "shorts" ? "10px" : "13px",
                                        boxShadow:
                                          "7px 7px 12px rgba(255, 255, 255, 0.3)",
                                      }}
                                      title={`Video ${index + 1}`}
                                    ></iframe>
                                  ))}
                                </div>

                                <CustomRightArrow />
                              </div>
                            </Tab.Pane>
                          ))}
                        </Tab.Content>
                      </Col>
                    </Row>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
